import Image from 'next/image';
import Link from 'next/link';
import { CardContent } from './CardContent';
import styles from './Card.module.scss';
import { imageLoader } from '../../utilities/imageLoader';

type ArticleCard = {
  authorImageSrc?: string;
  authorName: string;
  category: string;
  date: string;
  heading: string;
  isHero: boolean;
  imageSrc?: string;
  isTileWithImage: boolean;
  timeToRead: number;
  to: string;
};

const Card = ({
  authorImageSrc,
  authorName,
  category,
  date,
  imageSrc,
  heading,
  isHero,
  isTileWithImage,
  timeToRead,
  to,
}: ArticleCard) => {
  let image = (
    <div
      className={`${isHero ? styles['hero-image'] : ''} ${isTileWithImage ? styles['left-aligned-hero-image'] : ''}`}
      style={{ backgroundImage: 'url(data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D)' }}
    />
  );

  if (isHero) {
    image = (
      <div
        className={`${isHero ? styles['hero-image'] : ''} ${isTileWithImage ? styles['left-aligned-hero-image'] : ''}`}
        style={{ backgroundImage: `url(${`${imageSrc}?fm=webp`})` }}
      />
    );
  } else if (imageSrc) {
    image = (
      <div
        className={`${isHero ? styles['hero-image'] : ''} ${isTileWithImage ? styles['left-aligned-hero-image'] : ''}`}
      >
        <Image
          loader={imageLoader}
          src={`${imageSrc}?fm=webp&w=480&w=480&q=100`}
          alt={heading}
          layout="fill"
          unoptimized
          quality={100}
          objectPosition="center center"
        />
      </div>
    );
  }

  return (
    <div className={`${styles.root} ${isTileWithImage ? styles['tile-with-image-root'] : ''}`}>
      {image}

      <CardContent
        {...{
          heading,
          isHero,
          date,
          authorImageSrc,
          authorName,
          imageSrc,
          timeToRead,
          category,
          isTileWithImage,
        }}
      />
      <Link href={to} className={styles.link} aria-label={`Read more on ${heading}`} />
    </div>
  );
};

export { Card };
